import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const sections = document.querySelectorAll(".section-scrollTrigger");

// Set the first section as visible on load
if (sections[0]) {
    sections[0].classList.add("visible");
}

// Check visibility and add the 'visible' class to sections scrolled at least 30%
function checkVisibility() {
    sections.forEach((section) => {
        const sectionHeight = section.offsetHeight;
        const scrollPosition = window.scrollY + window.innerHeight;
        const sectionTop = section.getBoundingClientRect().top + window.scrollY;

        if (scrollPosition >= sectionTop + sectionHeight * 0.1 && !section.classList.contains("visible")) {
            section.classList.add("visible");
        }
    });
}

// Initialize visibility check on load
window.addEventListener("load", checkVisibility);

// Update visibility on scroll
ScrollTrigger.create({
    start: 0,
    end: "max",
    onUpdate: checkVisibility,
});
